import EastIcon from '@mui/icons-material/East';
import {
  GeneralTable,
} from "@/shared/components/ui";

import { IconButton, Tooltip } from "@mui/material";
import { EstadoFactibilidadCorporativaENUM, ROUTER_PATHS, TABLE_CONSTANTS, useTableFilter, useTableServerSideFiltering} from "@/shared";
import { useClientesCoorporativosColumns } from "./ClientesCoorporativosColumns";
import { useNavigate } from "react-router-dom";
import {  } from '@/shared/interfaces';
import { useFetchGetfactibilidadCorporativos } from '@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions';
import { CondicionVentaCorporativa } from '@/shared/interfaces/erp/prospecto/prospecto_corporativo.interface';
import { IFactibilidadCorporativo } from '@/shared/interfaces/erp/factibilidad_corporativo';
// import { useMaterialesUtilizadosStore } from '@/store/erp';

export interface ClientesCoorporativosTableMainProps {
  estado_factibilidad?:string;
  aceptado_factibilidad?:boolean;
  revisado_contabilidad?:boolean;
  canEditGlobal?:boolean;
}

const ClientesCoorporativosTableMain: React.FC<
  ClientesCoorporativosTableMainProps
> = ({
  estado_factibilidad=EstadoFactibilidadCorporativaENUM.EN_GESTION,
  aceptado_factibilidad=true,
  revisado_contabilidad=false,
  canEditGlobal=true
  // returnUrl,
  // pagination, setPagination,
  // columnFilters, setColumnFilters

}) => {
  const navigate = useNavigate();

  const returnUrl = ROUTER_PATHS.contabilidad.clientesCoorporativosNav;

  ///* table ---------------------------
  // server side filters - colums table
  // const { columnFilters, setColumnFilters } =
  //   useTableServerSideFiltering();
  // const { handleMethodChange, valueTab } = useTabsFormOnly({
  //   initialTabValue: 1,
  // });


  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;


  ///* fetch data ---------------------------
  const {
    data: factCoorporativaPagingRes,
    isLoading: isLoadingFactCoorporativa,
    isRefetching: isRefetchingFactCoorporativa,
  } = useFetchGetfactibilidadCorporativos(
    {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filterObject,
      filterByState: false,
      estado_factibilidad:estado_factibilidad,
      aceptado_factibilidad:aceptado_factibilidad,
      preaprobado_inventario:true,
      revisado_contabilidad:revisado_contabilidad,
      condicion_venta_in:`${CondicionVentaCorporativa.CANJE},${CondicionVentaCorporativa.EVENTO_GRATUITO},${CondicionVentaCorporativa.EVENTO_PAGADO}`,
      requiere_cotizacion:true
    }
  )
  // const clearSelectedItems = useMaterialesUtilizadosStore(
  //   s => s.clearSelectedItems
  // );
  // const { filterObject, columnFilters, setColumnFilters } =
  //   useTableServerSideFiltering();
  // const { handleMethodChange, valueTab } = useTabsFormOnly({
  //   initialTabValue: 1,
  // });

  // const {
  //   // globalFilter,
  //   pagination,
  //   searchTerm,
  //   // onChangeFilter,
  //   setPagination,
  //   // cleanFilter,
  // } = useTableFilter();
  // const { pageIndex, pageSize } = pagination;

  ///* columns ---------------------------
  const { clientesCorporativosColumns } = useClientesCoorporativosColumns();
  
  const onEdit = (original: IFactibilidadCorporativo) => {
    navigate(`${returnUrl}/${original.id_factibilidad_coorporativa}`);
  };
  return (
    <GeneralTable<IFactibilidadCorporativo>
      columns={clientesCorporativosColumns}
      data={factCoorporativaPagingRes?.data?.data || []}
      //
      isLoading={isLoadingFactCoorporativa}
      isRefetching={isRefetchingFactCoorporativa}
      // // filters - server side
      enableManualFiltering={true}
      columnFilters={columnFilters}
      onColumnFiltersChange={setColumnFilters}
      // // search
      enableGlobalFilter={false}
      // // pagination
      pagination={pagination}
      onPaging={setPagination}
      rowCount={factCoorporativaPagingRes?.data?.count}
      // // actions ========
      // enableColumnActions={hasAllPermissions([
      //   ...SAVE_CLIENTE_IFactibilidadCorporativo_PERMISSIONS,
      //   PermissionsEnum.api_change_IFactibilidadCorporativo,
      // ])}
      // enableEditing={hasAllPermissions([
      //   ...SAVE_CLIENTE_IFactibilidadCorporativo_PERMISSIONS,
      //   PermissionsEnum.api_change_IFactibilidadCorporativo,
      // ])}
      // canEdit={hasAllPermissions([
      //   ...SAVE_CLIENTE_IFactibilidadCorporativo_PERMISSIONS,
      //   PermissionsEnum.api_change_IFactibilidadCorporativo,
      // ])}
      actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
      enableColumnActions={canEditGlobal}
      enableEditing={canEditGlobal}
      // crud
      // onEdit={onEdit}
      canEdit={canEditGlobal}
      showCustomActionBtnSpace={canEditGlobal}
      onCustomEdit={(r)=>
        canEditGlobal?
          <Tooltip title={"Ir a detalle"} placement='top'>
            <IconButton
              onClick={() => {
                  onEdit(r!);
              }}
            >
              <EastIcon />
            </IconButton>
          </Tooltip>
        :<></>
      }
      // editIcon={<EastIcon />}
      toolTipTitleEditIcon="Ir a detalle"
      canDelete={false}
    />
  );
};
export default ClientesCoorporativosTableMain;